import { StrictMode } from 'react';
import { hydrateRoot, createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { ThemeProvider } from './lib/theme';
import { initSentry, SentryErrorBoundary } from './sentry';
import './index.css';

initSentry();

const container = document.getElementById('root')!;

const tree = (
  <StrictMode>
    <SentryErrorBoundary fallback={<div>Something went wrong. Please reload the page.</div>}>
      <ThemeProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ThemeProvider>
    </SentryErrorBoundary>
  </StrictMode>
);

// Prerendered HTML has element children inside #root; dev SPA does not (the
// `<!--app-html-->` placeholder parses as a comment node, so we check for
// element children specifically).
if (container.children.length > 0) {
  hydrateRoot(container, tree);
} else {
  createRoot(container).render(tree);
}
